import React from "react";
import { HtagProps } from "./Htag.props";

export const Htag = ({
	tag,
	type,
	children,
	className,
	onClick,
}: HtagProps): JSX.Element => {
	switch (tag) {
		case "h1":
			return (
				<h1
					className={`text-2xl cursor-default font-Neue  ${
						type === "light"
							? "font-light"
							: type === "regular"
							? "font-normal"
							: type === "medium"
							? "font-medium"
							: type === "semibold"
							? "font-semibold"
							: type === "bold"
							? "font-bold"
							: ""
					} ${className}`}
					onClick={onClick}
				>
					{children}
				</h1>
			);
		case "h2":
			return (
				<h2
					className={`text-[22px] cursor-default font-Neue  ${
						type === "light"
							? "font-light"
							: type === "regular"
							? "font-normal"
							: type === "medium"
							? "font-medium"
							: type === "semibold"
							? "font-semibold"
							: type === "bold"
							? "font-bold"
							: ""
					} ${className}`}
					onClick={onClick}
				>
					{children}
				</h2>
			);
		default:
			return <></>;
	}
};
